import { render, staticRenderFns } from "./AirportList.vue?vue&type=template&id=5d9787a2&scoped=true"
import script from "./AirportList.vue?vue&type=script&lang=js"
export * from "./AirportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9787a2",
  null
  
)

export default component.exports